import { Navigate } from "react-router-dom";
import { useAppSelector } from "../Redux/hooks";

const PrivateRoute = ({ element: Element }) => {
  const isAuthenticated = useAppSelector(
    (state) => state.auth.isAuthenticated
  );

  return isAuthenticated ? <Element /> : <Navigate to="/login" />;
};

export default PrivateRoute;
